module.exports = __webpack_public_path__ + "static/media/logo_320x320_transparent.0f798718.png";